module.exports = __webpack_public_path__ + "media/newstyle/images/icon-arrow-down-purple-white-e9360275618c143f877b8a16355b2bf5.svg";